import React from "react";
import { CCol, CRow } from "@coreui/react";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";

// Validation schema using Yup
const validationSchema = Yup.object({
  full_name: Yup.string().required("Full Name is required"),
  email: Yup.string().email("Invalid email format").required("Email is required"),
  subject: Yup.string().required("Subject is required"),
  message: Yup.string().required("Message is required"),
});

export default function Contact() {
  // Handle form submission
  const handleSubmit = (values, { resetForm }) => {
    axios
      .post("https://erp.rplconsultants.com.au/api/contacts", values)
      .then((response) => {
        // Show success alert and reset form
        alert("Your mail has been sent");
        resetForm(); // Reset the form fields
      })
      .catch((error) => {
        // Handle error
        console.error("There was an error submitting the form!", error);
        alert("There was an error sending your message. Please try again.");
      });
  };

  return (
    <Formik
      initialValues={{
        full_name: "",
        email: "",
        subject: "",
        message: "",
      }}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {() => (
        <Form>
          <CRow>
            <CCol lg={6} className="mb-3">
              <div className="form-input-wrapper">
                <Field type="text" name="full_name" placeholder="Enter Full Name" />
                <ErrorMessage name="full_name" component="div" className="error-message" />
              </div>
            </CCol>

            <CCol lg={6} className="mb-3">
              <div className="form-input-wrapper">
                <Field type="email" name="email" placeholder="Email Address" />
                <ErrorMessage name="email" component="div" className="error-message" />
              </div>
            </CCol>

            <CCol lg={12} className="mb-3">
              <div className="form-input-wrapper">
                <Field type="text" name="subject" placeholder="Subject" />
                <ErrorMessage name="subject" component="div" className="error-message" />
              </div>
            </CCol>

            <CCol lg={12} className="mb-3">
              <div className="form-input-wrapper">
                <Field as="textarea" name="message" rows={5} placeholder="Message" />
                <ErrorMessage name="message" component="div" className="error-message" />
              </div>
            </CCol>

            <CCol lg={12} className="mt-4">
              <div className="form-submit">
                <button type="submit" className="theme-primary-btn">
                  Send Message
                </button>
              </div>
            </CCol>
          </CRow>
        </Form>
      )}
    </Formik>
  );
}
